export const MULTIPLE_CHOICE = "multiple_choice";
export const MULTIPLE_CHOICE_NO_ANSWER = "multiple_choice_no_answer";

export function isMultipleChoiceLike(questionType: string | undefined | null): boolean {
  return questionType === MULTIPLE_CHOICE || questionType === MULTIPLE_CHOICE_NO_ANSWER;
}
